import '../configuracoes.css'

import { useState, useEffect } from 'react';

import { servRefreshMvAll } from '../../../servicos/servicosEmRotasPrivadas/mv-refresh';

import toast from 'react-hot-toast';

import DataMesControlled from '../../DataMesControlled';

import { toastErrorPydantic } from '../../../util/toast_pydantic'

function AtualizaGraficos() {

    console.log('### Iniciando AtualizaGraficos ###');

    const [dataInicial, setDataInicial] = useState(null)
    const [dataFim, setDataFim] = useState(null)

    const refreshMvAll = async () => {
        try {
            await toast.promise(
                servRefreshMvAll(dataInicial, dataFim),
                { 
                    loading: 'Atualizando gráficos...',
                    success: 'Os gráficos foram atualizados com sucesso!'
                }
            )
            setDataInicial(null);
            setDataFim(null);
        } catch (error) {
            toastErrorPydantic(error);
        }
    }

    return (
        <div className="container-configuracoes div-com-borda">
            <strong>
                <p className='m-0 fs-5'>Informe o mês inicial e o mês final para atualização dos gráficos</p>
            </strong>
            <div className='d-flex flex-column flex-md-row gap-3'>
                <div className='col-12 col-sm-3'>
                    <label className='text-nowrap' htmlFor='mes-inicial'>Mês inicial</label>
                    <DataMesControlled
                        id='mes-inicial'
                        value={dataInicial}
                        onChange={(v) => setDataInicial(v)}
                        getUltimoDia={false}
                    />
                </div>
                <div className='col-12 col-sm-3'>
                    <label className='text-nowrap' htmlFor='mes-final'>Mês final</label>
                    <DataMesControlled
                        id='mes-final'
                        value={dataFim}
                        onChange={(v) => setDataFim(v)}
                        getUltimoDia={false}
                    />
                </div>
            </div>
            <button
                className='btn btn-primary'
                onClick={(v) => refreshMvAll()}
            >
                ATUALIZAR
            </button>
        </div>
    )
}

export default AtualizaGraficos
